import { render, staticRenderFns } from "./TelegramSignInButton.vue?vue&type=template&id=4f0cc04a&lang=pug"
import script from "./TelegramSignInButton.vue?vue&type=script&lang=js"
export * from "./TelegramSignInButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports